import clsx, { ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

export const twMerge = extendTailwindMerge({
	extend: {
		classGroups: {
			"font-size": [
				{
					text: [
						"tiny_cap",
						"tiny",
						"small",
						"menu",
						"button",
						"body",
						"subheadline",
						"headline",
						"title5",
						"title4",
						"title3",
						"title2",
						"title1",
					],
				},
			],
		},
	},
})
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

export function debounce<T extends (...args: Parameters<T>) => ReturnType<T>>(fn: T, ms = 300) {
	let timeoutId: ReturnType<typeof setTimeout> | undefined

	return function (this: ThisParameterType<T>, ...args: Parameters<T>): void {
		if (timeoutId !== undefined) {
			clearTimeout(timeoutId)
		}
		timeoutId = setTimeout(() => fn.apply(this, args), ms)
	}
}
